<template>
	<div class="mapManage" ref="main" id="main">
		<iframe id="iframe" ref="iframe" :frameborder="0" src="https://lyapp.gispai.com/cgDownload2" class="iframe"></iframe>
	</div>
</template>
 
<script>
import {GetMyMapToken} from '@/api/staff'
export default {
	data() {
		return {

		};
	},
	mounted() {
		let token = JSON.parse(localStorage.getItem('user-token-gispai'))
		GetMyMapToken(token).then(res=>{
			if(res.data.state>0){
				const iframeWin = this.$refs['iframe'].contentWindow
				let user_gispai = JSON.parse(JSON.parse(localStorage.getItem("user_gispai")))
				if(res.data.state==2){
					localStorage.setItem('user-token-gispai', JSON.stringify(res.data.data));
					user_gispai.Token = res.data.data
					localStorage.setItem('user_gispai',JSON.stringify(JSON.stringify(user_gispai)))
					document.getElementById("iframe").onload=()=>{
					   iframeWin.postMessage({user:JSON.stringify(user_gispai)},'*')
					};
				}else{
					document.getElementById("iframe").onload=()=>{
					   iframeWin.postMessage({user:JSON.stringify(user_gispai)},'*')
					};
				} 
			}
		})
	},
	methods: {
	}
};
</script>

<style lang="less" scoped>
	.mapManage{
		height: 100vh;
		padding: 10px;
		.iframe {
			width: 100%;
			height: calc(100vh - 160px);
		}
	}
</style>
